import { render } from "./Content.vue?vue&type=template&id=1987c1e6"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kelvinwaithira/PhpstormProjects/realtor-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__